import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import ShopifyPosSignIn from './shopifypossignin.component.jsx';
import ContactValidationComponent from './contactvalidation.component.jsx';
import NewPayableDocument from './newpayabledocument.component.jsx';
const queryString = require('query-string')

class NewQuoteController extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {}
    }

    render() {
        return <ShopifyPosSignIn
            uri={queryString.parse(this.props.location.search)}
            redirect="/p/embedded/shopify/new-quote"
        >
            <ContactValidationComponent checkCart={true}>
                <NewPayableDocument documentType={'quotes'}></NewPayableDocument>
            </ContactValidationComponent>
        </ShopifyPosSignIn>
    }

}

export default injectIntl(NewQuoteController);


// WEBPACK FOOTER //
// ./src/embed/shopify/newquotecontroller.component.jsx